<template>
    <div>
        <b-card text-variant="white" class="text-center" title="Informasi terkait"
            style="background: linear-gradient(90.79deg, #2851A2 0.11%, #3751E4 98.98%);margin-top: 2%;">
            <div class="row">
                <div class="col-12 text-center">
                    <b-card style="color: black;margin-top: 0px !important;" text-variant="black">

                        <span>
                            Jenis Kelamin
                            <br />
                            <b>{{ this.jenisKelamin }}</b>
                        </span>
                    </b-card>
                </div>
                <!-- <div class="col-6">
                    <b-card style="color: black;margin-top: 0px !important;" text-variant="black">

                        <span>
                            Umur
                            <br />
                            <b>{{ this.age }}</b>
                        </span>
                    </b-card>
                </div> -->
            </div>
        </b-card>
    </div>
</template>

<style scoped>
.card-body {
    margin-top: 0px !important;
}
</style>

<script>
export default {
    props: {
        age: String,
        jenisKelamin: String
    },
    name: 'Card Aspek Jasmani'
}
</script>